import styled from "styled-components";

const StyledCourses = styled.div`
  padding: 48px 0 0 0;
  background-color: #ededed;
`;

const StyledCoursesH2 = styled.h2`
  margin-top: 0;
  margin-bottom: 24px;
`;

export { StyledCoursesH2 };

export default StyledCourses;
